module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0166.jpg?v=0c3970e9";